(function () {
  var STORAGE_KEY = 'gx-theme';
  var toggle = document.querySelector('[data-theme-toggle]');

  if (!toggle) return;

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    toggle.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    var current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    var next = current === 'dark' ? 'light' : 'dark';
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {}
    applyTheme(next);
  });

  applyTheme(document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');
})();